import { CalendarProvider } from "@modules/calendar/context/calendarContext"
import { useServicesContext } from "@modules/core/services/services.context"
import { usePlanningSessionEvents } from "@modules/training/hooks/useTraining"
import dayjs from "dayjs"
import { useCallback, useEffect, useState } from "react"
import { TrainingContent } from "../components/trainingContent"

export const TrainingPage: React.FC = () => {
  const [calendarRange, setCalendarRange] = useState<{ startDate: string; endDate: string }>()
  const { planningService } = useServicesContext()
  const { refetch } = usePlanningSessionEvents(calendarRange?.startDate, calendarRange?.endDate)

  useEffect(() => {
    planningService.initFilteredPrograms()
  }, [])

  const onDateSet = useCallback((startDate: dayjs.Dayjs | number, endDate: dayjs.Dayjs | number) => {
    setCalendarRange({ startDate: startDate.toString(), endDate: endDate.toString() })
  }, [])

  const refreshEvents = () => {
    refetch()
  }

  return (
    <CalendarProvider
      initialDate={dayjs().startOf("day")}
      onDateSet={onDateSet}
      defaultDisplayDetailedEvents={false}
      defaultView="dayGridWeek"
      refreshEvents={refreshEvents}
    >
      <TrainingContent calendarRange={calendarRange} />
    </CalendarProvider>
  )
}
